var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toexcel"},[_c('el-button',{staticClass:"button",staticStyle:{"width":"70px","height":"40px","position":"absolute","top":"7px","right":"190px"},attrs:{"type":"primary"},on:{"click":_vm.exportExcel}},[_vm._v("导出")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }